export const LOCAL_STORAGE_USER = "tymber-user";
export const DEFAULT_DELIVERIES_PATH = "/deliveries";

export const RELEASE_LEVELS = {
  PRODUCTION: "production",
  QA: "qa",
  DEVELOPMENT: "development",
};
